import { getConfigFromDict, log } from './utils.js'
import { packageList, remoteModulesConfig } from './package-list/index'

export const version = '0722'

export const defaultRemoteMode = false

export const envMock = ''

export const entryFileVersion = new Date().getTime()

export const grayRemoteMark = '-gray'

// 是否小包环境, 小包环境不启用远程模块
export const subPackageName = location.pathname ? location.pathname.replace(/\//ig, '') : ''


// name: 'sys' 包名
// activeRule: ['ams', 'mcs', 'uamp', 'urm'] 匹配的路由, 模块名称
// entry: 'http://localhost:4005/mcs/static/js/mcs-module-entry.js' 模块入口，可省略
// publicPath: 'http://localhost:4005/mcs/ 可省略
export const basePackageList = packageList

if (!window.__REMOTE_MODULE_BASE_CONFIG__) {
  window.__REMOTE_MODULE_BASE_CONFIG__ = basePackageList
}

if (!window.__REMOTE_MODULE_ENV_CONFIG__) {
  window.__REMOTE_MODULE_ENV_CONFIG__ = remoteModulesConfig
}


export function getModuleList (env) {
  if (!env) { // 本地开发环境调试
    env = 'dev'
  }
  const envPackageConfig = {
    dev: localStorage.__REMOTE_MODULE_DEBUG_DEV__ || getConfigFromDict('dev') || [], // dev: ['sys', 'tms', 'fms', 'hr'],
    uat: localStorage.__REMOTE_MODULE_DEBUG_UAT__ || getConfigFromDict('uat') || [],
    stg: localStorage.__REMOTE_MODULE_DEBUG_STG__ || getConfigFromDict('stg') || [],
    prd: localStorage.__REMOTE_MODULE_DEBUG_PRD__ || getConfigFromDict('prd') || [],
    sit: localStorage.__REMOTE_MODULE_DEBUG_PRD__ || getConfigFromDict('prd') || [], // 培训环境, 与生产同步
    str: localStorage.__REMOTE_MODULE_DEBUG_UAT__ || getConfigFromDict('uat') || [], // 压测环境, 与uat同步
  }
  log('获取所有环境配置: ', envPackageConfig)
  const pkgs = envPackageConfig[env] || []
  log('当前环境配置: ', pkgs)
  return basePackageList.filter(pkg => pkgs.indexOf(pkg.name) > -1)
}

const postfix = `-module-entry`

// baseUrl: 部署路径
// postfix: 入口文件后缀
export const envConfigs = {
  dev: {
    baseUrl: 'https://edge.dev.kye-erp.com',
    postfix
  },
  uat: {
    baseUrl: 'https://static-uat.kye-erp.com', // cdn
    postfix
  },
  str: {
    baseUrl: 'https://static-uat.kye-erp.com', // cdn
    postfix
  },
  sit: {
    baseUrl: 'https://static.kye-erp.com', // sit 用生产的文件
    postfix
  },
  stg: {
    baseUrl: 'https://static-stg.kye-erp.com', // cdn
    postfix
  },
  prd: {
    baseUrl: 'https://static.kye-erp.com', // cdn
    postfix,
    multiModuleBaseUrl: 'https://static-uat-yongdao.kye-erp.com', // 生产泳道环境的baseUrl地址
  }
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/config.js